import routes from '@/modules/forms/forms-routes';
import store from '@/modules/forms/forms-store';

export default {
    routes,
    store,
}
